import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
import axios from 'axios';
export default {
  name: 'lab_mng',
  components: {
    dotBmap: function dotBmap() {
      return import('@/components/dotBmap.vue');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '企业管理',
        addFunName: 'labAdd',
        modifyFunName: 'labModify',
        queryFunName: 'labQuery',
        detailFunName: 'labDetail',
        delFunName: 'labDel'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time'
      }
      // , formData: { state:'Active' }
      ,
      formData: {
        showSimulate: false
      },
      rules: {
        name: [{
          required: true,
          message: '请输入企业名称',
          trigger: 'blur'
        }]
      },
      accessDialogShow: false,
      accessData: {},
      emptyAccessFormData: {
        accessDigital: false,
        accessCockpit: false,
        cockpitCustom: false,
        accessSmartIot: false,
        accessVideo: false,
        accessProduction: false,
        accessEnergy: false,
        accessFanli: false,
        accessSource: false,
        accessFeed: false,
        accessDisease: false,
        accessPatrol: false
      },
      accessRules: {
        digitalTwinUrl: [{
          required: true,
          message: '请输入数字孪生地址',
          trigger: 'blur'
        }],
        modelUrl: [{
          required: true,
          message: '请输入智能模型地址',
          trigger: 'blur'
        }],
        cockpitCustomRoute: [{
          required: true,
          message: '请输入定制化驾驶舱路由',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '140px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      console.log('initFormData paramData.geoFence', paramData.geoFence);
      // if(paramData.geoFence){
      //   paramData.geoFence = JSON.parse(paramData.geoFence)
      // }
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    initAccessFormData: function initAccessFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.accessData = paramData;
      if (typeof this.$refs['accessFormDataVerify'] !== 'undefined') {
        this.$refs['accessFormDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this.initFormData(res.data);
        _this.editDialogTitle = _this.pageConfig.editPageName + '维护';
        _this.editDialogShow = true;
      });
    },
    access: function access(data) {
      this.accessData = JSON.parse(JSON.stringify(data));
      this.accessDialogShow = true;
    },
    del: function del(id) {
      var _this2 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this2.$api[_this2.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this2.$message.success('删除成功');
            _this2.query();
          } else {
            _this2.$message.error('删除失败');
          }
        });
      });
    },
    getFence: function getFence(val) {
      console.log('getFence', val);
      this.$set(this.formData, 'geoLng', val.point.lng);
      this.$set(this.formData, 'geoLat', val.point.lat);
      this.$set(this.formData, 'geoFence', val.polygonPath ? JSON.stringify(val.polygonPath) : '');
    },
    query: function query() {
      var _this3 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this3.tableData = res.data || [];
        _this3.totalCount = res.count;
        _this3.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this4 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this4.formData.id) {
            _this4.$api[_this4.pageConfig.modifyFunName](_this4.saveFormDataProcess(_this4.formData)).then(function (res) {
              if (res.data) {
                _this4.$message.success('编辑成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('编辑失败');
              }
            });
          } else {
            _this4.$api[_this4.pageConfig.addFunName](_this4.saveFormDataProcess(_this4.formData)).then(function (res) {
              if (res.data) {
                _this4.$message.success('新增成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    changeSwitch: function changeSwitch(row) {
      var _this5 = this;
      this.$confirm('确定调整吗？').then(function () {
        _this5.$api[_this5.pageConfig.modifyFunName](_this5.saveFormDataProcess(row)).then(function (res) {
          if (res.data) {
            _this5.$message.success('编辑成功');
          } else {
            row.showSimulate = !row.showSimulate;
            _this5.$message.error('编辑失败');
          }
        });
      });
    },
    submitAccessFormData: function submitAccessFormData() {
      var _this6 = this;
      this.$refs['accessFormDataVerify'].validate(function (valid) {
        if (valid) {
          _this6.$api['labAccess'](_this6.accessData.id, _this6.saveFormDataProcess(_this6.accessData)).then(function (res) {
            if (res.data) {
              _this6.$message.success('授权成功');
              _this6.initAccessFormData(_this6.emptyAccessFormData);
              _this6.accessDialogShow = false;
              _this6.query();
            } else {
              _this6.$message.error('授权失败');
            }
          });
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};